import { Navigate, Route, Routes } from "react-router-dom";
import Sidebar from "./_components/SideBar";
import InfoLayout from "components/InfoLayout";
import { UserInfoProvider } from "./_context/UserinfoContext";
import MainPage from "views/users/user-info/main";
import Settings from "views/users/user-info/settings";
import RolesDataTable from "views/users/user-info/roles";
import { useTranslation } from "react-i18next";

const UserInfo = () => {
  const { t } = useTranslation();

  const HEADER_MAP = {
    "/": {
      title: t("users.userInfo.title"),
      subtitle: t("users.userInfo.subtitle"),
    },
    "/roles": {
      title: t("users.userInfo.rolesTitle"),
      subtitle: t("users.userInfo.rolesSubtitle"),
    },
    "/settings": {
      title: t("users.userInfo.settingsTitle"),
      subtitle: t("users.userInfo.settingsSubtitle"),
    },
  };

  const getGroupHeaderKey = (location: Location): string => {
    const path = location.pathname.replace(/\/+$/, "").split("/").pop() || "";
    return path === "" ? "/" : `/${path}`;
  };

  return (
    <InfoLayout
      Provider={UserInfoProvider}
      Sidebar={Sidebar}
      headerMap={HEADER_MAP}
      getHeaderKey={getGroupHeaderKey}
    >
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/roles" element={<RolesDataTable />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to={"/dashboard/users"} />} />
      </Routes>
    </InfoLayout>
  );
};

export default UserInfo;
